import { render } from "./SummaryProductSection.vue?vue&type=template&id=f194b3c4"
import script from "./SummaryProductSection.vue?vue&type=script&lang=js"
export * from "./SummaryProductSection.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./SummaryProductSection.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_6d8875c6%2Fpackages%2Fstore%2Fsrc%2Fcomponents%2Fpos%2Fsubscription%2Fformwithsteps%2FSummaryProductSection.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__